/**
 * @file IconArrowDown Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-arrow-down',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 16 16">
  <g>
    <g />
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        fill-rule="evenodd"
        d="M2.868623,4.662188L8,10.26005L13.1313,4.6623L13.1314,4.662138Q13.2025,4.584652,13.2987,4.542326Q13.3949,4.5,13.5,4.5Q13.5492,4.5,13.5975,4.509607Q13.6458,4.519215,13.6913,4.53806Q13.7368,4.556906,13.7778,4.584265Q13.8187,4.611625,13.8536,4.646447Q13.8884,4.681269,13.9157,4.722215Q13.9431,4.763161,13.9619,4.808658Q13.9808,4.854155,13.9904,4.9024549Q14,4.9507543,14,5Q14,5.0938219,13.966,5.181262Q13.932,5.268701,13.8686,5.337862L13.8684,5.338025L8.36858,11.33786Q8.35389,11.35389,8.33786,11.36858Q8.26455,11.435780000000001,8.1711,11.46982Q8.077639999999999,11.50385,7.97828,11.49953Q7.87892,11.49521,7.78877,11.45319Q7.69863,11.41118,7.63142,11.33786L2.131469,5.337913L2.131423,5.337862Q2.068025,5.268701,2.034013,5.181261Q2,5.0938219,2,5Q2,4.9507543,2.009607,4.9024549Q2.019215,4.854155,2.0380599999999998,4.808658Q2.056906,4.763161,2.084265,4.722215Q2.111625,4.681269,2.146447,4.646447Q2.181269,4.611625,2.222215,4.584265Q2.263161,4.556906,2.308658,4.53806Q2.354155,4.519215,2.4024549,4.509607Q2.4507543,4.5,2.5,4.5Q2.605115,4.5,2.701332,4.542326Q2.797548,4.584652,2.868577,4.662138L2.868623,4.662188Z"
      />
    </g>
  </g>
</svg>
`
);
